import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "reload-form px-md sm:px-0 layout-column gap-sm+ items-center" };
const _hoisted_2 = { class: "typography-headline-2 text-center max-w-[290px]" };
const _hoisted_3 = { class: "button-wrapper" };
import { OrButtonV3 as OrButton, } from '@onereach/ui-components';
import LoginContainer from '../layouts/LoginContainer.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AnotherUserPage',
    setup(__props) {
        const reload = () => {
            window.parent.postMessage({ type: 'AUTH_SESSION_EXPIRATION_RELOAD' }, '*');
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(LoginContainer, {
                ref: "cookieExpireModal",
                class: "relogin-modal",
                background: true
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('session_expire.You signed in with another account')), 1),
                        _createElementVNode("div", _hoisted_3, [
                            _createVNode(_unref(OrButton), {
                                class: "reload h-2xl",
                                color: "primary",
                                onClick: reload
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('session_expire.Reload')), 1)
                                ]),
                                _: 1
                            })
                        ])
                    ])
                ]),
                _: 1
            }, 512));
        };
    }
});
